import api from './api';

export interface DashboardData {
  task_summary: {
    total: number;
    completed: number;
    in_progress: number;
    pending: number;
    overdue: number;
  };
  topic_summary: {
    total: number;
    covered: number;
  };
  budget_summary: {
    total_budget: number;
    total_paid: number;
    total_due_on_wedding_day: number;
  };
  guest_summary: {
    total_invited: number;
    total_expected_to_attend: number;
  };
}

export const getDashboard = () => api.get<DashboardData>('/dashboard');
